import { AUTH } from '../constants/actionTypes'
import * as api from '../api'

export const login = (formData, history) => async (dispatch) => {
    const {data} = await api.login(formData)
    dispatch({type: AUTH, payload: data})
    history.push('/')
}
export const register = (formData, history) => async (dispatch) => {
    const {data} = await api.register(formData)
    dispatch({type: AUTH, payload: data})
    history.push('/')
}